import React from 'react';

function StorybookGrid({ 
  storybooks, 
  isPurchased = false, 
  bundleMode = false, 
  selectedForBundle = [], 
  onToggleSelection = () => {}, 
  purchasedStorybookIds = [],
  isFeatured = false
}) {
  const StorybookCard = require('./StorybookCard').default;
  
  if (!storybooks || storybooks.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="w-20 h-20 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
          <i className="fas fa-book-reader text-gray-400 text-3xl"></i>
        </div>
        <h3 className="text-2xl font-bold text-gray-800 mb-2">لا توجد قصص</h3>
        <p className="text-gray-600">لم يتم العثور على أي قصص في الوقت الحالي</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
      {storybooks.map((storybook, index) => (
        <div 
          key={storybook.id}
          className={isFeatured && index === 3 ? 'lg:hidden' : ''}
        >
          <StorybookCard 
            storybook={storybook} 
            isPurchased={isPurchased || purchasedStorybookIds.includes(storybook.id)}
            bundleMode={bundleMode}
            isSelected={selectedForBundle.some(s => s.id === storybook.id)}
            onToggleSelection={() => onToggleSelection(storybook)}
          />
        </div>
      ))}
    </div>
  );
}

export default StorybookGrid;
